// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N01nY","col":"styles_col__1XbUY"};